import { TOWNS } from "@/content/site";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {TOWNS.map((town, i) => (
      <span key={town} className="flex items-center">
        <span
          className={`px-6 text-4xl font-medium tracking-[-0.035em] sm:px-10 sm:text-6xl ${i % 2 ? "text-outline" : "text-white/85"}`}
        >
          {town}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-[#2F6BFF]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section
    aria-label="Towns we serve"
    className="marquee-wrap marquee-mask relative overflow-hidden border-y border-white/[0.08] py-10 sm:py-14"
    data-testid="towns-marquee"
  >
    <p className="sr-only">
      We work with businesses in Wayne, NJ and about 30 miles around, including {TOWNS.slice(1).join(", ")}.
    </p>
    <div className="marquee-track" aria-hidden="true">
      <Row />
      <Row hidden />
    </div>
  </section>
);
